module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_0.1f7ffa48.png";